import { removeElement as y, queryElement as a, createElement as h } from "./highrise1049.mjs";
import q from "./highrise1184.mjs";
typeof window < "u" && (window.__cssrContext = {});
function v(c, e, n, f) {
  const { els: o } = e;
  if (n === void 0)
    o.forEach(y), e.els = [];
  else {
    const u = a(n, f);
    u && o.includes(u) && (y(u), e.els = o.filter((s) => s !== u));
  }
}
function E(c, e) {
  c.push(e);
}
function x(c, e, n, f, o, u, s, t, m) {
  let i;
  if (n === void 0 && (i = e.render(f), n = q(i)), m) {
    m.adapter(n, i ?? e.render(f));
    return;
  }
  t === void 0 && (t = document.head);
  const l = a(n, t);
  if (l !== null && !u)
    return l;
  const r = l ?? h(n);
  if (i === void 0 && (i = e.render(f)), r.textContent = i, l !== null)
    return l;
  if (s) {
    const d = t.querySelector(`meta[name="${s}"]`);
    if (d)
      return t.insertBefore(r, d), E(e.els, r), r;
  }
  return o ? t.insertBefore(r, t.querySelector("style, link")) : t.appendChild(r), E(e.els, r), r;
}
export {
  x as mount,
  v as unmount
};
